export const roles = {
  SysAdmin: 'SysAdmin',
}
